import { ReactElement } from 'react'
import { InputGroup, Text, Grid } from '@raskrask-dk/rr-components'
import { useTranslation } from 'react-i18next'
import { SpecialCareText } from './styles'
import { PropsSpecialCareFieldTemplate } from './props'

const SpecialCareFieldTemplate = ({
    specialCare,
    setSpecialCare,
}: PropsSpecialCareFieldTemplate): ReactElement => {
    const { t } = useTranslation()

    return (
        <Grid gap={16}>
            <InputGroup
                checked={specialCare}
                data-cy="specialCareCheckbox"
                label={t('details.form.specialcare.label')}
                labelPlacement="end"
                onChange={() => setSpecialCare(!specialCare)}
                type="checkbox"
            />
            {specialCare && (
                <SpecialCareText>
                    <Text primary bold>
                        {t(`details.form.specialcare.info.header`)}
                    </Text>
                    <Text primary>
                        {t(`details.form.specialcare.info.description`)}
                    </Text>
                </SpecialCareText>
            )}
        </Grid>
    )
}

export default SpecialCareFieldTemplate
